import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePivotButton} from '#core/application/modules/tiles/pivot/index.js';
import {generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

export function myAccountDialogFactory(PALETTE) {
    const BASE_BUTTON = {
        padding: '0 8px',
        height: '40px', // important to have height here since height 100% doesn't work on some elements (such as betslip tabs)
        alignItems: 'center',
    };

    return {
        MyAccount: {
            dialog: {
                dialogContent: {
                    style: {
                        ...resolveBackground(PALETTE.MY_ACCOUNT_DIALOG_CONTAINER_BG),
                    },
                },
                header: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.MY_ACCOUNT_DIALOG_HEADER_BG),
                            height: '48px',
                        },
                    },
                    title: {
                        container: {
                            padding: '0 0 0 16px',
                            width: '100%',
                        },
                        style: {
                            lineHeight: '24px',
                            ...PALETTE.MY_ACCOUNT_DIALOG_HEADER_TEXT,
                        },
                    },
                },
                closeButton: generateCloseButton(PALETTE.MY_ACCOUNT_DIALOG_CLOSE_BUTTON),
                closeButtonContainer: {
                    style: {
                        height: 48, // to align it with header title
                        top: 0,
                    },
                },
                centered: {
                    width: '948px',
                },
            },
            tabs: {
                container: {
                    style: {
                        minHeight: '100%',
                    },
                },
                tabButtons: {
                    container: {
                        style: {
                            _desktop_alignItems: 'center',
                        },
                    },
                    selectableButton: {
                        selected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.MY_ACCOUNT_DIALOG_TAB_BUTTON_SELECTED_TEXT,
                                    ...resolveBackground(PALETTE.MY_ACCOUNT_DIALOG_TAB_BUTTON_SELECTED_BG),
                                },
                            },
                        },
                        unselected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.MY_ACCOUNT_DIALOG_TAB_BUTTON_TEXT,
                                    ...resolveBackground(PALETTE.MY_ACCOUNT_DIALOG_TAB_BUTTON_BG),
                                },
                            },
                        },
                        indicator: {
                            style: {
                                base: {
                                    height: 0,
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
            },
            scrollPane: {
                direction: 'x',
            },
            subTabs: {
                tabButtons: {
                    container: {
                        style: {
                            height: 'auto',
                            flexFlow: 'wrap',
                        },
                    },
                    selectableButton: generatePivotButton(PALETTE.MY_ACCOUNT_DIALOG_TAB_SELECTOR),
                },
            },
        },
    };
}
